import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useReportsCompactCache } from '~/reports-compact-cache';
import Dimmer from '+/Dimmer';
import Swal from '#/swal';
import { makeStyles } from '@material-ui/core/styles';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { clearCompactCache } from '~/clear-compact-cache';
import { IconButton } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    clearCacheButton: {
        position: 'relative',
        '&:hover': {
            backgroundColor: 'red'
        }
    }
}));

const List = () => {

    const {
        isLoading, isError, data, isFetching
    } = useReportsCompactCache();

    const classes = useStyles();

    if (isLoading || isFetching) {
        return <Dimmer />;
    }

    if (isError) {
        return 'Internal Error - Contact Technical Support';
    }

    const ClearCache = async (entrata_report_name, property_id) => await clearCompactCache(entrata_report_name, property_id);

    const clearCacheHandler = (entrata_report_name, property_id) => {

        ClearCache(entrata_report_name);

        Swal.fire(
            'Cache Dropped',
        `You have dropped the Cache ${ entrata_report_name } correctly!`,
        'success'
        );

    };

    const columns = [
        {
            field: 'report_name',
            headerName: 'Report Name',
            width: 350,
            editable: false
        },
        {
            field: 'expires_in',
            headerName: 'Expires In',
            width: 350,
            editable: false
        },
        {
            field: 'clear_cache',
            headerName: 'Clear Cache',
            type: 'string',
            width: 180,
            renderCell: params => (

                <div className='App'>
                    <IconButton
                        color='inherit'
                        className={classes.clearCacheButton}
                        onClick={() => clearCacheHandler(params.row.report_name)}>
                        <CancelOutlinedIcon />
                    </IconButton>
                </div>


            )
        }
    ];

    const reports_cache_data = [];
    data.map(x => {
        reports_cache_data.push({

            id: x.id,
            report_name: x.report_name,
            cache_name: x.cache_name,
            expires_in: x.expires_in

        });

        return reports_cache_data;
    });

    return (


        <div style={{
            height: 600,
            width: '100%'
        }}>
            <DataGrid
                rows={reports_cache_data}
                columns={columns}
                experimentalFeatures={{ newEditingApi: true }}
                oncha
            />
        </div>
    );
};

export default List;
